import {remCalc} from '_themeUtils'

const selectedRefinements = {
    SelectedRefinements: {
        baseStyle: () => ({
            wrapper: {
                flexWrap: 'wrap',
                w: '100%',
                pt: {base: 'spacing.4', xl: 'spacing.5'},
                gap: 'spacing.3',
            },
            drawerVariant: {
                p: 'spacing.4',
                borderTop: '1px solid',
                borderColor: 'color.border.grey.300',
            },
            resetText: {
                display: {base: 'none', md: 'block'},
                color: 'color.text.black',
                letterSpacing: remCalc(1),
                fontWeight: 400,
                ml: 'spacing.1',
                cursor: 'pointer',
            },
        }),
    },
}

export default selectedRefinements
